export const HEARTBEAT_START = "HEARTBEAT_START";
export const HEARTBEAT_STOP = "HEARTBEAT_STOP";
export const HEARTBEAT_SUCCESS = "HEARTBEAT_SUCCESS";
export const HEARTBEAT_FAILURE = "HEARTBEAT_FAILURE";

export const heartbeatStart = () => ({
    type: HEARTBEAT_START,
});

export const heartbeatStop = () => ({
    type: HEARTBEAT_STOP,
});

export const heartbeatSuccess = () => ({
    type: HEARTBEAT_SUCCESS,
});

export const heartbeatFailure = (error) => ({
    type: HEARTBEAT_FAILURE,
    payload: error,
});
